export function addSessionEventHandlers(sessionService, appInsights) {
    sessionService.on('session:start', function (user) { return appInsights.setAuthenticatedUserContext(user.curtinId); });
    sessionService.on('session:end', function () { return appInsights.clearAuthenticatedUserContext(); });
    var current = sessionService.current();
    if (current != null)
        appInsights.setAuthenticatedUserContext(current.curtinId);
}
